// [system] IPC wrapper — calls Electron main process for ESC/POS printing
// Falls back to window.print() when running in web (non-Electron) mode

const isElectron = () =>
  typeof window !== 'undefined' && !!window.electronAPI?.isElectron;

/**
 * Print a receipt via ESC/POS (Electron) or window.print() (web fallback).
 * @param {string} type - receipt | bill | cashStart | cashTransaction | voidBill | qrTable
 * @param {object} data - data for the specific receipt type
 * @param {Function} [onFallback] - called when falling back to window.print()
 * @returns {Promise<{ok: boolean, error?: string}>}
 */
export async function electronPrint(type, data, onFallback) {
  if (isElectron()) {
    const result = await window.electronAPI.print(type, data);
    return result;
  }

  // web fallback
  if (onFallback) onFallback();
  window.print();
  return { ok: true, fallback: true };
}

export async function testPrint(config) {
  if (!isElectron()) return { ok: false, error: 'NOT_ELECTRON' };
  return window.electronAPI.testPrint(config);
}

export async function listPrinters() {
  if (!isElectron()) return { ok: false, printers: [] };
  return window.electronAPI.listPrinters();
}

export async function getPrinterConfig() {
  if (!isElectron()) return { ok: false, config: null };
  return window.electronAPI.getPrinterConfig();
}

export async function setPrinterConfig(config) {
  if (!isElectron()) return { ok: false, error: 'NOT_ELECTRON' };
  return window.electronAPI.setPrinterConfig(config);
}

export { isElectron };
